module.exports = __webpack_public_path__ + "img/engagement.7e544809.jpeg";